"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendNotificationDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
class SendNotificationDto {
}
exports.SendNotificationDto = SendNotificationDto;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], SendNotificationDto.prototype, "eventType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], SendNotificationDto.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], SendNotificationDto.prototype, "emailId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], SendNotificationDto.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsObject)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], SendNotificationDto.prototype, "parameters", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], SendNotificationDto.prototype, "additionalUserId", void 0);
